import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-requisition-authorisation-trail',
    templateUrl: './requisition-authorisation-trail.component.html',
    styleUrls: ['./requisition-authorisation-trail.component.scss']
})
export class RequisitionAuthorisationTrailComponent implements OnInit {

    @Input() requisition: any = [];

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/components/requisition-authorisation-trail/requisition-authorisation-trail.component.ts